// 常時開閉できるアコーディオン(応募規約・FAQなど)
// 開閉をアニメーションさせるため hidden 属性(display: none)ではなくクラスで制御する。
// 閉じている間の非表示はCSS側の visibility: hidden が担保する。
const setupAccordion = (trigger) => {
  const body = document.getElementById(trigger.getAttribute('aria-controls'));

  trigger.addEventListener('click', () => {
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    body.classList.toggle('is-open', !expanded);
  });
};

// SPだけアコーディオンになり、PCでは常に開いたまま(応募方法の加入済みケース)
// is-collapsible が付いている間だけCSS側で折りたためる状態になる。
// PCでは外すので、CSSは何も足さなくても常に開いた見た目に戻る。
const setupSpOnlyAccordion = (trigger) => {
  const body = document.getElementById(trigger.getAttribute('aria-controls'));
  const mq = window.matchMedia('(max-width: 767px)');

  const applyMode = () => {
    if (mq.matches) {
      trigger.disabled = false;
      trigger.setAttribute('aria-expanded', 'false');
      body.classList.add('is-collapsible');
      body.classList.remove('is-open');
    } else {
      trigger.disabled = true;
      trigger.removeAttribute('aria-expanded');
      body.classList.remove('is-collapsible', 'is-open');
    }
  };

  trigger.addEventListener('click', () => {
    if (!mq.matches) return;
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    body.classList.toggle('is-open', !expanded);
  });

  mq.addEventListener('change', applyMode);
  applyMode();
};

document.querySelectorAll('[data-accordion]').forEach((trigger) => {
  if (trigger.hasAttribute('data-accordion-sp')) {
    setupSpOnlyAccordion(trigger);
  } else {
    setupAccordion(trigger);
  }
});

// タブ切り替え
document.querySelectorAll('[role="tablist"]').forEach((tablist) => {
  const tabs = [...tablist.querySelectorAll('[role="tab"]')];

  const select = (tab) => {
    tabs.forEach((t) => {
      const selected = t === tab;
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
      t.classList.toggle('is-active', selected);
      document.getElementById(t.getAttribute('aria-controls')).hidden = !selected;
    });
  };

  tablist.addEventListener('click', (e) => {
    const tab = e.target.closest('[role="tab"]');
    if (tab) select(tab);
  });

  tablist.addEventListener('keydown', (e) => {
    const i = tabs.indexOf(document.activeElement);
    if (i === -1) return;
    let next;
    if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
    else return;
    e.preventDefault();
    tabs[next].focus();
    select(tabs[next]);
  });
});
